export const footerContent = {
  signup: {
    title: "Stay tuned to the frequency",
    placeholder: "EMAIL ADDRESS",
    button: "JOIN"
  },
  quote: "There is no enemy. Just toxic energy you used to tolerate.",
  columns: {
    movement: ["About", "Goals", "Contact"],
    shop: ["NFT (0.23 SOL)", "Physical Art ($55)"],
    connect: ["Email Signup", "Social Links"]
  }
};